export class ChangePasswordState { 
    verificationCode!: string;
    newPassword!: string;
    email?: string;
}